import React from "react";
import TSLogo from "../../assets/images/TS-Logo.png";
import LogoDark2x from "../../images/custom/ts-logo.png";
import {Link} from "react-router-dom";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/branch-dashboard`} className="logo-link">
      <img className="logo-light logo-img" src={TSLogo} alt="logo" />

    </Link>
  );
};

export default  Logo;
